module.exports = __webpack_public_path__ + "img/next-arrow--small.33fc408f.svg";